import * as React from 'react';

import { ComboBanner } from './ComboBanner';
import { DealImage } from './DealImageTile';
import { ImageBanner } from './ImageBanner';
import { MessageBanner } from './MessageBanner';
import { ProductBanner } from './ProductBanner';
import { PromoBanner } from './PromoBanner';
import { ThinTitleProductBanner } from './ThinTitleProductBanner';

type Template = {
  [key: string]: React.FC<any>;
};

export const Templates: Template = {
  ComboBanner,
  DealImage,
  ImageBanner,
  MessageBanner,
  ProductBanner,
  PromoBanner,
  ThinTitleProductBanner,
};
